import React from 'react';
import { Shield, Users, Heart, CheckCircle } from 'lucide-react';

const TrustBar = () => {
  const trustItems = [
    {
      icon: Users,
      text: 'Über 5.000 Familien beraten'
    },
    {
      icon: Heart,
      text: 'Persönliche Beratung garantiert'
    },
    {
      icon: CheckCircle,
      text: 'Ohne Gesundheitsprüfung'
    }
  ];

  return (
    <section className="trust-bar">
      <div className="container-custom">
        <div className="trust-bar-content">
          {/* Google Badge with rating */}
          <div className="trust-item google-rating">
            <div className="google-mini-badge">
              <div className="google-icon">
                <svg width="28" height="28" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                  {/* Official Google G Icon */}
                  <path fill="#4285F4" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"/>
                  <path fill="#34A853" d="M6.3 14.7l6.6 4.8C14.4 16.1 18.7 13 24 13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 16.1 2 9.3 6.2 6.3 14.7z"/>
                  <path fill="#FBBC05" d="M24 46c5.5 0 10.5-2 14.4-5.4l-6.7-5.2C29.6 37.1 26.9 38 24 38c-6.4 0-11.8-4.3-13.8-10.1l-6.5 5C6.6 40.9 14.4 46 24 46z"/>
                  <path fill="#EA4335" d="M44.5 20H24v8.5h11.8c-.9 2.8-2.7 5.2-5.1 6.8l6.7 5.2c4.8-4.4 7.6-10.9 7.6-18.5 0-1.3-.2-2.7-.5-4z"/>
                </svg>
              </div>
              <div className="rating-text">
                <div className="rating-number">5,0 ★★★★★</div>
                <div className="rating-count">600+ Bewertungen</div>
              </div>
            </div>
          </div>

          {/* Trust items */}
          {trustItems.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="trust-item">
                <IconComponent className="trust-icon" size={20} />
                <span>{item.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
